import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useShortlist } from '../hooks/useShortlist';
import './Search.css';

function formatPriceFull(p) {
  if (!p) return null;
  return '$' + p.toLocaleString();
}

function ShortlistCard({ property, reasons }) {
  const navigate = useNavigate();
  return (
    <div className="listing-card" onClick={() => navigate(`/bid/${property.id}`)}>
      <div className="card-img" style={{ background: '#dde8f2' }}>
        <svg className="house-svg" viewBox="0 0 80 60">
          <polygon points="40,5 75,35 65,35 65,58 15,58 15,35 5,35" fill="#185FA5" opacity="0.35" />
          <rect x="30" y="38" width="20" height="20" fill="#185FA5" opacity="0.5" />
        </svg>
      </div>
      <div className="card-body">
        <div className="card-price">{formatPriceFull(property.asking_price)}</div>
        <div className="card-addr">{property.address}</div>
        <div className="card-city">{property.city}, {property.state} {property.zip}</div>
        <div className="card-meta">
          <span>{property.beds} bd</span>
          <span>{property.baths} ba</span>
          <span>{property.sqft?.toLocaleString()} sqft</span>
        </div>
        {reasons.length > 0 && (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5, marginBottom: 10 }}>
            {reasons.slice(0, 3).map(r => (
              <span key={r} className="badge badge-green" style={{ fontSize: 10 }}>{r}</span>
            ))}
          </div>
        )}
        <div className="card-actions">
          <button className="btn btn-primary btn-sm" onClick={e => { e.stopPropagation(); navigate(`/bid/${property.id}`); }}>
            place bid
          </button>
        </div>
      </div>
    </div>
  );
}

export default function Shortlist() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { shortlist, loading, hasPreferences } = useShortlist();

  if (!user) return (
    <div className="page" style={{ textAlign: 'center', padding: 60 }}>
      <p style={{ color: 'var(--text-secondary)', marginBottom: 16 }}>Sign in to see your personalized shortlist.</p>
      <button className="btn btn-primary" onClick={() => navigate('/')}>go home</button>
    </div>
  );

  return (
    <div className="page">
      <div style={{ marginBottom: 20 }}>
        <h1 style={{ fontSize: 22, fontWeight: 600 }}>for you</h1>
        <p style={{ color: 'var(--text-secondary)', fontSize: 13 }}>
          Homes picked to match your saved preferences — timeline, location, budget, and must-haves.
        </p>
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', padding: 40, color: 'var(--text-secondary)' }}>finding your best matches...</div>
      ) : !hasPreferences ? (
        <div className="card" style={{ textAlign: 'center', padding: 40 }}>
          <p style={{ color: 'var(--text-secondary)', marginBottom: 16 }}>
            You haven't set your buyer preferences yet. Complete the short preferences panel (shown when you're signed in) so we can personalize your shortlist.
          </p>
          <button className="btn btn-primary" onClick={() => navigate('/search')}>browse all homes instead</button>
        </div>
      ) : shortlist.length === 0 ? (
        <div className="card" style={{ textAlign: 'center', padding: 40 }}>
          <p style={{ color: 'var(--text-secondary)', marginBottom: 16 }}>
            No active listings match your preferences yet. We'll keep looking — check back soon, or browse everything available now.
          </p>
          <button className="btn btn-primary" onClick={() => navigate('/search')}>browse all homes</button>
        </div>
      ) : (
        <div className="listings-grid">
          {shortlist.map(({ property, reasons }) => (
            <ShortlistCard key={property.id} property={property} reasons={reasons} />
          ))}
        </div>
      )}
    </div>
  );
}
